module.exports = __webpack_public_path__ + "static/media/VDF.b62c55f7.webm";